import { Heart, Home, Users } from "lucide-react";

const AboutProgram = () => {
  return (
    <section id="sobre" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6 text-foreground">
            O que é o programa <span className="text-[hsl(var(--orange-strong))]">Minha Casa Mais Bonita?</span>
          </h2>
          
          <div className="text-lg md:text-xl text-muted-foreground leading-relaxed space-y-6 mb-12">
            <p>
              O <strong className="text-foreground">Minha Casa Mais Bonita</strong> é um programa criado pela Taboca Arquitetura e Cidades para ajudar famílias de baixa renda a reformar ou melhorar suas casas com segurança, qualidade e orientação profissional.
            </p>
            
            <p>
              Agora, com o novo programa do governo federal <strong className="text-foreground">Reforma Casa Brasil</strong>, operado pela Caixa, você pode conseguir recursos para realizar pequenas reformas — e a Taboca te ajuda em todas as etapas: do projeto à execução.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-card rounded-2xl p-6 text-center shadow-[var(--shadow-card)] hover:shadow-[var(--shadow-warm)] transition-all">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] flex items-center justify-center mx-auto mb-4">
                <Home className="h-8 w-8 text-white" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-foreground">Reformas com qualidade</h3>
              <p className="text-muted-foreground">
                Orientação profissional em cada etapa da sua obra
              </p>
            </div>

            <div className="bg-card rounded-2xl p-6 text-center shadow-[var(--shadow-card)] hover:shadow-[var(--shadow-warm)] transition-all">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[hsl(var(--orange-medium))] to-[hsl(var(--orange-light))] flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-white" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-foreground">Apoio especializado</h3>
              <p className="text-muted-foreground">
                Arquitetos qualificados cuidando do seu projeto
              </p>
            </div>

            <div className="bg-card rounded-2xl p-6 text-center shadow-[var(--shadow-card)] hover:shadow-[var(--shadow-warm)] transition-all">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[hsl(var(--orange-light))] to-[hsl(var(--golden))] flex items-center justify-center mx-auto mb-4">
                <Heart className="h-8 w-8 text-white" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-foreground">Dignidade e conforto</h3>
              <p className="text-muted-foreground">
                Transformando sua casa em um lar ainda melhor
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutProgram;
